import { Injectable, Inject } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { map, mergeMap, catchError } from "rxjs/operators";
import { throwError } from 'rxjs';
import * as uuid from "uuid";
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from './toastr.service';

@Injectable({
    providedIn: "root"
})
export class FileService {

    className = 'FileService';

    constructor(private http: HttpClient, @Inject("environment") private environment: any,
        private translateService: TranslateService, private toastService: ToastrService) { }

    uploadURL(key): any {


        let body = {
            key: key
        }

        return this.http.post(this.environment.base_URL + "/upload/url", body).pipe(catchError(err => {
            this.toastService.add({
                severity: "error",
                summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
                detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_DETAIL"), life: 5000
            });
            return throwError(err);
        }));
    }

    upload(file, entityType, entityId,  originVisibility?: string) {
        //generate key s3
        let key = uuid.v4() + "/" + _.get(file, 'name');
        
        let type: string = _.get(file, 'type') === '' ? 'application/octet-stream' : _.get(file, 'type');

        //override filename to match url
        let blob = file.slice(0, _.get(file, 'size'), type);
        let fileUpdated = new File([blob], key, { type: type });

        //generate presigned url
        return this.uploadURL(key).pipe(mergeMap((url: any) => {
            //const headers = {'Content-Type': _.get(file,'type'), 'x-amz-acl': 'public-read'};
            const headers = { 'Content-Type': type };
            const options: any = { headers: headers };
            //use presigned url
            return this.http.put(url, fileUpdated, options);
        }), mergeMap(res => {
            //file is upload to s3
            //tell GAIA
            return this.http.post(this.environment.base_URL + "/upload", {
                type: entityType,
                id: entityId,
                name: key,
                contentType: type,
                //url is generated in lambda
                url: null,
                originVisibility: originVisibility ?? null
            })
        }), map(res => {
            this.delete(key).subscribe(() => { });
            return res;
        }), catchError(err => {
            this.toastService.add({
                severity: "error",
                summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
                detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_DETAIL"), life: 5000
            });
            return throwError(err);
        }))
    }
    downloadSpecial(key,idDoc, entityType, entityId, contentType){
        let body = {
            idFile: idDoc,
            type: entityType,
            id: entityId,
            name: key,
            contentType,
            //url is generated in lambda
            url: null,
            key: key
        }
    return this.http.post(this.environment.base_URL + `/download`, body).pipe(mergeMap((res: any) => {
        let options = {
            responseType: "blob" as 'json'
        }
        return this.http.get(res, options);
           }), map(res => {
               this.delete(key).subscribe(() => { });
               return res;
               }), catchError(err => {
               this.toastService.add({
                   severity: "error",
                   summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
                   detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_DETAIL"), life: 5000
               });
           return throwError(err);
        }))
    }

    download(key, entityType, entityId, contentType) {

        let body = {
            type: entityType,
            id: entityId,
            name: key,
            contentType,
            //url is generated in lambda
            url: null,
            key: key
        }
        return this.http.post(this.environment.base_URL + `/download`, body)
            .pipe(mergeMap((res: any) => {
                let options = {
                    responseType: "blob" as 'json'
                }
                return this.http.get(res, options);
            }), map(res => {
                this.delete(key).subscribe(() => { });
                return res;
            }), catchError(err => {
                this.toastService.add({
                    severity: "error",
                    summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
                    detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_DETAIL"), life: 5000
                });
                return throwError(err);
            }))
    }

    delete(key): any {
        let params = {
            key
        }
        return this.http.post(this.environment.base_URL + "/delete", { params }).pipe(catchError(err => {
            this.toastService.add({
                severity: "error",
                summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
                detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_DETAIL"), life: 5000
            });
            return throwError(err);
        }));
    }

}